


















import { computed, defineComponent } from '~/utils/nuxt3-migration'
import { CategoryId } from '~/models/category/types'
import CCategoryIcon from '~/components/shared/configurable/category/CCategoryIcon.vue'
import { resolveCategory } from '~/utils/category'
import { categoriesSolidIconsMappings } from '~/constants/category/icon'

export default defineComponent({
  components: { CCategoryIcon },
  props: {
    url: { type: String, default: '', required: false },
    title: { type: String, default: '', required: true },
    id: { type: Number, default: null, required: true },
    isNuxtUrl: { type: Boolean, default: false }
  },
  setup(props) {
    const linkAttrs = computed(() => {
      if (!props.url) {
        return {}
      }
      if (props.isNuxtUrl && !props.url.startsWith('http')) {
        return {
          to: props.url
        }
      }
      return {
        href: props.url
      }
    })

    const icon = computed(() => {
      return resolveCategory(categoriesSolidIconsMappings, [props.id])
    })

    return {
      CategoryId,
      linkAttrs,
      icon
    }
  }
})
